import type { FC } from "react";
import { Tag, TagIntent } from "widgets";

import { IndexStatus } from "@/graphql.js";

export const IndexStatusTag: FC<{ status?: string | null }> = ({ status }) => {
  switch (status) {
    case IndexStatus.Exists:
      return <Tag intentColor={TagIntent.Success} label={"Indexed"} />;
    case IndexStatus.Indexing:
      return <Tag intentColor={TagIntent.Warning} label={"Indexing"} />;
    case IndexStatus.Missing:
      return <Tag intentColor={TagIntent.Danger} label={"Missing Index"} />;
    case IndexStatus.Cancelled:
      return <Tag intentColor={TagIntent.Danger} label={"Indexing Cancelled"} />;
    case IndexStatus.Failed:
      return <Tag intentColor={TagIntent.Danger} label={"Indexing Failed"} />;
  }

  return null;
};
